import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ReportsPage } from '@/features/reports/pages/reports-page';

export const Route = createFileRoute('/_app/reports')({
  validateSearch: z.object({ run: z.string().optional() }),
  component: ReportsPage,
});
